module.exports = __webpack_public_path__ + "img/mustard.854b08d5.png";